import React, { Fragment, useEffect, useState } from "react";
import {
  VlogPlaylistCard,
  VlogSectionHeading,
  VlogVideoCard,
} from "@modules/study/common/vlog";
import { Grid, Pagination } from "@mui/material";
import Link from "next/link";
import styles from "./recent_videos.module.scss";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import { useRouter } from "next/router";

const links = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Vlog",
    link: "/vlog",
  },
  {
    title: "Most Recent Videos",
    link: "/vlog/recent",
  },
];

export const RecentVideosList = ({ recentVideo }) => {
  const router = useRouter();

  const [paginate, setPaginate] = useState({
    currentPage: recentVideo.currentPage,
    limit: recentVideo.limit,
    page_total: recentVideo.page_total,
    total: recentVideo.total,
  });

  useEffect(() => {
    if (recentVideo.currentPage) {
      setPaginate((prev) => ({
        ...prev,
        currentPage: recentVideo.currentPage,
      }));
    }
  }, [recentVideo.currentPage]);

  const paginationHandler = (e, page) => {
    e.preventDefault();
    router.push(`/vlog/recent?limit=24&page=${page}`);
  };

  return (
    <Fragment>
      <VlogSectionHeading links={links} title="Most Recent Videos" />
      <section>
        <div className="container">
          <Grid container spacing={4}>
            {recentVideo &&
              recentVideo?.results?.length > 0 &&
              recentVideo?.results?.map((item, i) => (
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12} key={i}>
                  <VlogVideoCard item={item} />
                </Grid>
              ))}
          </Grid>
          {paginate && paginate.total > paginate.limit && (
            <PaginationComponent
              paginate={paginate}
              paginationHandler={paginationHandler}
            />
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default RecentVideosList;
